import React from 'react';
import './style.sass';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallText from '../../../common-components/common-small-text';

const taskPointList = {
    content:
        '<p>Главная цель рекламной кампании&nbsp;&mdash; это сбор заявок от&nbsp;абитуриентов на&nbsp;поступление.</p>',
};

const Goal = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper bigPaddings={true} isMargin={true} className="mid-goal">
                <div className="mid-goal__wrapper">
                    <div className="mid-goal__grid">
                        <div className="mid-goal__img">
                            <img src="/images/svg/mid/goal.svg" alt="" loading="lazy" />
                        </div>
                        <div className="mid-goal__content">
                            <CommonTitle className="mid-goal__title">Цель</CommonTitle>
                            <CommonSmallText className="mid-goal__text">
                                <div dangerouslySetInnerHTML={{ __html: taskPointList.content }} />
                            </CommonSmallText>
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Goal;
